import React, { useState, useMemo } from "react";

import {
  Form,
  Input,
  Button,
  Select as AntdSelect,
  message,
  Checkbox,
} from "antd";
import OnboardingLayout from "../../layouts/Onboarding";
//import PhoneInput from "react-phone-input-2";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import countryList from "react-select-country-list";
import ReactSelect from "react-select";
import countries from "world-countries";
import { create } from "../../services/apiService";
import { useAuth } from "../../context/AuthContext";
import { useHistory, useNavigate } from "react-router-dom";

const SignUp = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const options = useMemo(() => countryList().getData(), []);
  const [value, setValue] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [form] = Form.useForm();
  const { userProfile, updateProfile } = useAuth();
  const [formData, setFormData] = useState({});
  const [cellValue, setCellValue] = useState(null);
  const [rawInput, setRawInput] = useState("");

  const countryOptions = countries.map((country) => ({
    value: country.cca2,
    label: `${country.flag} ${country.name.common}`, // Adds emoji flag
  }));

  const CustomInput = React.forwardRef((props, ref) => (
    <input
      {...props}
      ref={ref}
      className="block w-full px-4 py-3 ml-2 pl-12 border rounded-lg shadow-sm text-gray-900 focus:ring-brand-secondary focus:border-brand-secondary focus:outline-none"
    />
  ));

  const navigate = useNavigate();

  const next = async () => {
    try {
      // Validate fields for the current step
      const values = await form.validateFields();

      // Update the form data with current step data
      setFormData((prevData) => ({
        ...prevData,
        ...values, // Add new fields to the accumulated formData
      }));

      // Proceed to the next step
      setCurrentStep((prev) => prev + 1);
    } catch (error) {}
  };

  const prev = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleChange = (selectedOption) => {
    setValue(selectedOption);
  };

  // const handlePhoneChange = (value, country) => {
  //   // Try to parse and format the number
  //   const parsedNumber = parsePhoneNumberFromString("+" + value, country?.countryCode?.toUpperCase());

  //   if (parsedNumber?.isValid()) {
  //     setCellValue(parsedNumber.format("E.164")); // Correctly formatted: +278148989019
  //   } else {
  //     setCellValue("+" + value); // fallback
  //   }
  // };

  // const handlePhoneChange = (value, country) => {

  //   try {
  //     const parsed = parsePhoneNumberFromString("+" + value, country.countryCode?.toUpperCase());

  //     if (parsed?.isValid()) {
  //       setCellValue(parsed.format("E.164")); // => +27814879019
  //     } else {
  //       setCellValue(""); // or fallback
  //     }

  //     //setCellValue(formattedValue);
  //     form.setFieldsValue({ cellphone: parsed.format("E.164") });

  //   } catch (err) {
  //     setCellValue(null); // invalid input
  //   }
  // };

  const handlePhoneChange = (value, country) => {
    const fullValue = `+${value}`;

    const phoneNumber = parsePhoneNumberFromString(
      fullValue,
      country.countryCode?.toUpperCase()
    );
    if (phoneNumber && phoneNumber.isValid()) {
      const formatted = phoneNumber.format("E.164"); // +27123456789
      setCellValue(formatted);
      form.setFieldsValue({ cellphone: formatted });
    } else {
      setCellValue(fullValue); // fallback if libphonenumber can't parse
      form.setFieldsValue({ cellphone: fullValue });
    }
  };

  const handleSubmit = async () => {
    try {
      // Validate all fields before submitting
      // if (!cellValue) {
      //   message.error("Please enter a valid phone number.");
      //   return;
      // }

      //form.setFieldsValue({ cellphone: cellValue });

      const values = await form.validateFields();

      // Combine form data from all steps
      const data = { ...formData, ...values };
      data["country"] = data.country.label;
      data["authId"] = userProfile.authId;

      // Send data to the API
      const response = await create("/api/v1/update-profile", data);

      if (response.status == 201 && response.data.data) {
        updateProfile(response.data.data);
        navigate("/onboarding/verify", { replace: true });
      }

      // Handle success (e.g., redirect or show success message)
    } catch (error) {
      // Handle error (e.g., show error message)
    }
  };

  const steps = [
    {
      title: "Name",
      content: (
        <>
          <h2 className="text-2xl font-semibold text-brand-primary py-6">
            Let's get your name
          </h2>
          <Form.Item
            name="title"
            rules={[{ required: true, message: "Please select a title" }]}
          >
            <AntdSelect
              //size="middle"
              className="rounded-lg  border-gray-300 w-full"
              placeholder="Select your title"
              style={{ height: 50, width: "100%" }}
            >
              <AntdSelect.Option value="Mr">Mr.</AntdSelect.Option>
              <AntdSelect.Option value="Mrs">Mrs.</AntdSelect.Option>
              <AntdSelect.Option value="Miss">Ms.</AntdSelect.Option>
              <AntdSelect.Option value="Dr.">Dr.</AntdSelect.Option>
              <AntdSelect.Option value="Prof.">Prof.</AntdSelect.Option>
            </AntdSelect>
          </Form.Item>
          <Form.Item
            name="name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input
              className="rounded-lg p-3 border-gray-300"
              placeholder="Name"
            />
          </Form.Item>
          <Form.Item
            name="surname"
            rules={[{ required: true, message: "Please enter your surname" }]}
          >
            <Input
              className="rounded-lg p-3 border-gray-300"
              placeholder="Surname"
            />
          </Form.Item>
        </>
      ),
    },
    {
      title: "Referral",
      content: (
        <Form.Item name="referralCode">
          <Input
            className="rounded-lg p-3 border-gray-300"
            placeholder="Enter referral code (optional)"
          />
        </Form.Item>
      ),
    },
    {
      title: "Phone Number",
      content: (
        // <Form.Item name="cellphone" rules={[{ required: true, message: "Please enter your phone number" }]}>
        //   <PhoneInput
        //     country={"za"}
        //     inputClass="rounded-lg p-3 border-gray-300"
        //     containerClass="w-full"
        //     buttonClass="border-gray-300"
        //     inputProps={{
        //       name: "cellphone",
        //       required: true,
        //       className: `block w-full px-4 py-3 ml-12 pl-12 border rounded-lg shadow-sm text-gray-900 focus:ring-brand-secondary focus:border-brand-secondary focus:outline-none`,
        //     }}
        //     placeholder="Phone number"
        //   />
        // </Form.Item>
        <Form.Item
          name="cellphone"
          //rules={[{ required: true, message: "Please enter your phone number" }]}
          rules={[
            { required: true, message: "Phone number is required" },
            {
              validator: (_, value) =>
                isValidPhoneNumber(value)
                  ? Promise.resolve()
                  : Promise.reject(""),
            },
          ]}
        >
          {/* <PhoneInput
            country={"za"}
            placeholder="Phone number"
            //value={cellValue}
            value={cellValue.replace(/^\+/, '')}
            onChange={handlePhoneChange}
            inputClass="rounded-lg p-3 border-gray-300"
            containerClass="w-full"
            buttonClass="border-gray-300"
            inputProps={{
              name: "cellphone",
              required: true,
              className: `block w-full px-4 py-3 ml-12 pl-12 border rounded-lg shadow-sm text-gray-900 focus:ring-brand-secondary focus:border-brand-secondary focus:outline-none`,
            }}
            // onChange={(value, country) => {
            //   const phoneNumber = parsePhoneNumberFromString("+" + value);
            //   if (phoneNumber && phoneNumber.isValid()) {
            //     setCellValue(phoneNumber.format('E.164')); // e.g., +27123456789
            //   } else {
            //     setCellValue(value); // fallback
            //   }
            // }}
          /> */}
          <PhoneInput
            defaultCountry="ZA"
            international
            countryCallingCodeEditable={false}
            value={cellValue}
            //onChange={setCellValue}
            placeholder="Enter phone number"
            inputComponent={CustomInput}
          />
        </Form.Item>
      ),
    },
    {
      title: "Country",
      content: (
        <Form.Item
          name="country"
          rules={[{ required: true, message: "Please select your country" }]}
        >
          <ReactSelect
            options={options}
            value={value}
            onChange={handleChange}
            placeholder="Select your country"
            className="w-full text-black"
          />
        </Form.Item>
      ),
    },
    // {
    //   title: "General Terms",
    //   content: (
    //     <div>
    //       <Form.Item name="marketingConsent" valuePropName="checked" rules={[{ required: true, message: "You must accept the terms and conditions" }]}>
    //         <label className="flex items-center space-x-2">
    //           <input type="checkbox" className="rounded border-gray-300" />
    //           <span>I consent to receive marketing material from 80Eight</span>
    //         </label>
    //       </Form.Item>
    //       <Form.Item name="termsAccepted" valuePropName="checked" rules={[{ required: true, message: "You must accept the terms and conditions" }]}>
    //         <label className="flex items-center space-x-2">
    //           <input type="checkbox" className="rounded border-gray-300" />
    //           <span>I accept the{" "}
    //             <a href="/terms" className="text-red-500 font-semibold hover:underline">Terms and Conditions</a>
    //           </span>
    //         </label>
    //       </Form.Item>
    //     </div>
    //   ),
    // },
    {
      title: "General Terms",
      content: (
        <div>
          <Form.Item name="marketingConsent" valuePropName="checked">
            <Checkbox>
              I consent to receive marketing material from 80Eight
            </Checkbox>
          </Form.Item>

          <Form.Item
            name="termsAccepted"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error("You must accept the terms and conditions")
                      ),
              },
            ]}
          >
            <Checkbox onChange={() => form.validateFields(["termsAccepted"])}>
              I accept the{" "}
              <a
                href="https://80eight.io/app-terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-500 font-semibold hover:underline"
              >
                Terms and Conditions
              </a>
            </Checkbox>
          </Form.Item>
        </div>
      ),
    },
  ];

  const totalSteps = steps.length;
  const progress = (currentStep / (totalSteps - 1)) * 100;

  return (
    <OnboardingLayout currentStep={currentStep} goBack={prev}>
      <div className="w-full max-w-xl mx-auto px-4 py-8 flex flex-col items-center">
        <div className="w-full mb-10">
          <div className="relative h-2 w-full bg-gray-300 rounded-full">
            <div
              className="absolute top-0 left-0 h-2 bg-gradient-to-r from-brand-secondary to-accent-magenta rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
              aria-hidden="true"
            />
            <div className="absolute top-0 left-0 w-full h-2 flex justify-between">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center"
                >
                  <div
                    className={`w-6 h-6 rounded-full border-2 transition-all duration-300 flex items-center justify-center ${
                      index < currentStep
                        ? "bg-brand-secondary border-brand-secondary"
                        : index === currentStep
                          ? "bg-accent-magenta border-accent-magenta"
                          : "bg-white border-gray-300"
                    }`}
                  />
                  <div className="mt-2 text-sm font-semibold text-gray-600">
                    {step.title}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto mb-6 mt-10">
          <Form form={form} layout="vertical">
            {steps[currentStep].content}
          </Form>
        </div>

        <div className="mt-6 flex flex-col items-center space-y-4 w-full max-w-md">
          {currentStep < steps.length - 1 ? (
            <button
              type="primary"
              onClick={next}
              className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-lg w-full"
            >
              Next
            </button>
          ) : (
            <button
              type="primary"
              onClick={handleSubmit}
              className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-lg w-full"
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default SignUp;
